import {combineEpics} from 'redux-observable';
import EpicFactory from "../../../../framework/factory/EpicFactory";
import PaymentOfflineEpic from "./payment/type/PaymentOfflineEpic";

export default combineEpics(
  EpicFactory.get(PaymentOfflineEpic)
);



// WEBPACK FOOTER //
// ./src/extension/payment-offline/view/epic/index.js